
export const BillingOrganizationsActionTypes = {
    SET_BILLING_ORGANIZATIONS: "SET_BILLING_ORGANIZATIONS",
    SET_ORGANIZATION_DETAIL: "SET_ORGANIZATION_DETAIL",
    UPDATED_ORG_REFRESH: "UPDATED_ORG_REFRESH",
    CLEAR_BILLING_DETAILS: "CLEAR_BILLING_DETAILS",
    TOGGLE_BILLING_ORG_SORT: "TOGGLE_BILLING_ORG_SORT",
    BILLING_ORG_GLOBAL_SEARCH: "BILLING_ORG_GLOBAL_SEARCH",
}

export const addEditBillingOrgActionTypes = {
    SETTING_BILLING_ORG_FORM_VALUE: "SETTING_BILLING_ORG_FORM_VALUE",
    VALIDATE_BILLING_ORG_FORM: "VALIDATE_BILLING_ORG_FORM",
    TOGGLE_ADD_BILLING_ORG_MODAL: "TOGGLE_ADD_BILLING_ORG_MODAL",
    TOGGLE_EDIT_BILLING_ORG_MODAL: "TOGGLE_EDIT_BILLING_ORG_MODAL",
    OPEN_EDIT_BILLING_ORG_MODAL: "OPEN_EDIT_BILLING_ORG_MODAL",

    VALIDATE_CP_USER: "VALIDATE_CP_USER",
    TOGGLE_ENABLE_CP_MODAL: "TOGGLE_ENABLE_CP_MODAL"
}

export const apiActionsBillingOrg = {
    GET: "GET_ORGANIZATION_DETAIL",
    GET_ALL: "FETCH_ALL_BILLING_ORGANIZATIONS",
    GET_SERVICE_IDS: "GETTING_ASSOCIATED_SERVICE_IDS",
    POST: "ADD_NEW_ORG",
    PUT: "EDIT_CURRENT_ORG",
    DELETE_CURRENT_ORG: "DELETE_CURRENT_ORG",
    DELETE_WARNING_FOR_BILLING: "DELETE_WARNING_FOR_BILLING",

    CREATE_CP_USER: "CREATE_CP_USER",
    GET_ORG_TENANTS_AND_COUNTRIES: "GET_ORG_TENANTS_AND_COUNTRIES",
}

export const orgTenantsCountriesActionTypes = {
    SET_ORG_TENANTS_COUNTRIES: "SET_ORG_TENANTS_COUNTRIES",
    SET_ORG_TENANTS_COUNTRIES_LOADING: "SET_ORG_TENANTS_COUNTRIES_LOADING",
    SET_ORG_TENANTS_COUNTRIES_ERROR: "SET_ORG_TENANTS_COUNTRIES_ERROR",
}

export const BillingOrgSortFields = {
    NAME: "display_name",
}
